import { pick, mapValues } from "lodash";
import Cookies from "js-cookie";
import queryString from "query-string";
import debug from "debug";

const log = debug("velpic:signup:utm");

const utmParams = [
	"utm_source",
	"utm_medium",
	"utm_campaign",
	"utm_term",
	"utm_content",
];

export function processUTMParams() {
	// convert query string to object
	const searchParams = queryString.parse(window.location.search);

	// Only pull valid UTM params not all query params
	const campaignParams = pick(searchParams, utmParams);

	// If the user came in with utm params, we'll take them over the stored ones
	if (campaignParams && Object.keys(campaignParams).length !== 0) {
		// Test for missing utm_source or utm_medium
		const noSourceOrMedium =
			!campaignParams.utm_source || !campaignParams.utm_medium;

		// Test for organic search referral
		const searchReferral = /https?:\/\/(.*)\.(google|bing|yahoo)\.([^/?]*)/.exec(
			document.referrer
		);

		// Sensible defaults for missing utm_source or utm_medium
		if (noSourceOrMedium) {
			campaignParams.utm_source = campaignParams.utm_source || "direct";
			campaignParams.utm_medium = campaignParams.utm_medium || "none";

			if (searchParams.gclid) {
				campaignParams.utm_source = "google";
				campaignParams.utm_medium = "cpc";
			} else if (searchReferral) {
				campaignParams.utm_source = searchReferral[2];
				campaignParams.utm_medium = "organic";
			} else if (document.referrer) {
				campaignParams.utm_source = document.referrer;
				campaignParams.utm_medium = "referral";
			}
		}

		const date = new Date();
		date.setTime(date.getTime() + 365*24*60*60*1000);

		Cookies.set("utmTracker", campaignParams, {
			secure: true,
			domain: process.env.NODE_ENV === "development" ? "localhost" : ".velpic.com",
			expiry: date.toUTCString(),
		});

		return mapValues(campaignParams, val => Array.isArray(val) ? val[0] : val);
	} else {
		// User hasn't come in with any params, so we see if there are any stored
		let cookieObj = Cookies.get("utmTracker");

		// we return an object for consistency no matter where the cookie came from
		try {
			cookieObj = JSON.parse(cookieObj);
		} catch (err) {
			log(`Failed to parse UTM cookie data: ${err.message}. Cookie value: ${cookieObj}`);
			cookieObj = {};
		}

		return mapValues(cookieObj, val => Array.isArray(val) ? val[0] : val);
	}
}
